<div class="wrap">


  <div class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active"
        appChangeColorTheme attribute="color"></fa-icon>
      <h2>{{title}}</h2>
    </div>

  </div>

  <section [hidden]="helps.length === 0 || isLoading" class="content">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">
      <ng-container matColumnDef="videoHelpKey">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Video key </th>
        <td mat-cell *matCellDef="let help">
          <fa-icon [icon]="getFaIcon('faChevronDown')" matTooltip="Ouvrir l'aide" appChangeColorTheme attribute="color" class="expand-icon" *ngIf="help !== this.expandedElement" (click)="expandRow(help, $event)"></fa-icon>
          <fa-icon [icon]="getFaIcon('faChevronUp')" matTooltip="Fermer l'aide" appChangeColorTheme attribute="color" class="expand-icon" *ngIf="help === this.expandedElement" (click)="expandRow(help, $event)"></fa-icon>
          {{ help.videoHelpKey}} </td>
      </ng-container>

      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Localisation </th>
        <td mat-cell *matCellDef="let help">{{ help.location}} </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Titre </th>
        <td mat-cell *matCellDef="let help">{{ help.title}} </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
        <td mat-cell *matCellDef="let help">{{ help.description}} </td>
      </ng-container>

      <ng-container matColumnDef="nbrVideos">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nbre vidéos </th>
        <td mat-cell *matCellDef="let help">{{ help.nbrVideos}} </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
        <td mat-cell *matCellDef="let help" class="actionsCell">
          <fa-icon [icon]="getFaIcon('faPlus')" matTooltip="Ajouter une aide vidéo sur cette rubrique" appChangeColorTheme attribute="color" (click)="$event.stopPropagation();openDialogAddEditHelp('add', help)"></fa-icon>
          <fa-icon [icon]="getFaIcon('faEye')" matTooltip="Visualiser la rubrique" appChangeColorTheme attribute="color" (click)="$event.stopPropagation();openDialogHelp(help.videoHelpKey, help)"></fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td class="expandedrow" mat-cell *matCellDef="let help" [attr.colspan]="displayedColumns.length">
          <div class="example-element-detail" [@detailExpand]="(help.videoHelpKey == keyExpanded) ? 'expanded' : 'collapsed'">
            <div class="helpVideosTable">
              <app-admin-sub-video-help [subVideoHelp]="help.subVideoHelp" [help]="help"></app-admin-sub-video-help>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"  (click)="expandRow(element, $event)">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent = $event" [color]="color">
    </mat-paginator>
  </section>

  <mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>

  <ng-container *ngIf="helps.length === 0 && !isLoading">
    <p>Il n'y a pas d'aides vidéos.</p>
  </ng-container>

</div>
